import React from 'react'

const HoursBadge = ({
  showHoursTooltip,
  toggleHoursTooltip,
  hoursButtonRef,
  tooltipRef,
  dotOpen,
  effectiveLabel,
  filteredOpen,
  filteredOnline,
  compressDays,
  dayNames
}) => {
  return (
    <div className="nav-status">
      <div className="nav-status-wrapper">

        <button
          type="button"
          ref={hoursButtonRef}
          className={`nav-status-badge nav-status-badge--clickable${
            showHoursTooltip ? ' nav-status-badge--active' : ''
          }`}
          onClick={toggleHoursTooltip}
          aria-expanded={showHoursTooltip}
          aria-haspopup="true"
          title="Voir les horaires d'ouverture"
        >
          <span
            className={
              'nav-status-dot ' +
              (dotOpen ? 'nav-status-dot--open' : 'nav-status-dot--closed')
            }
            aria-hidden="true"
          />

          <div className="nav-status-texts">
            <span className="nav-status-line nav-status-main">
              {effectiveLabel}
            </span>
          </div>

          <span className="nav-status-chevron" aria-hidden="true">
            {showHoursTooltip ? '▲' : '▼'}
          </span>
        </button>

        {showHoursTooltip && (
          <div ref={tooltipRef} className="nav-hours-dropdown" role="tooltip">

            <p className="nav-hours-dropdown-title">
              Horaires d'ouverture
            </p>

            {filteredOpen.length > 0 && (
              <div className="nav-hours-section">
                <p className="nav-hours-subtitle">Ouvert</p>

                {filteredOpen.map((g, i) => (
                  <p key={i}>
                    {compressDays(g.days, dayNames)} : {g.open} - {g.close}
                  </p>
                ))}
              </div>
            )}

            {filteredOnline.length > 0 && (
              <div className="nav-hours-section">
                <p className="nav-hours-subtitle">Commande en ligne</p>

                {filteredOnline.map((g, i) => (
                  <p key={i}>
                    {compressDays(g.days, dayNames)} : jusqu’à {g.lastOrder}h
                  </p>
                ))}
              </div>
            )}

          </div>
        )}

      </div>
    </div>
  )
}

export default HoursBadge